<template>
  <v-form ref="form" class="mt-3 mx-3">
    
    <BaseUtil
      ref="util"
      :pageLoading="pageLoading"
    />

    <v-row>
      
      <v-col cols="12" sm="6" md="8">
        <v-autocomplete
          v-model="entry.varietyId"
          v-bind="getObject('varietyId')"
          label="Variedade"
          :items="extraData.globalContext.allVarieties"
          item-value="id"
          item-text="title"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <VarietyNew
              :inlineAddButton="true"
              @entry-created="varietyCreated"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="4">
        <v-text-field
          v-model="entry.barcode"
          v-bind="getObject('barcode')"
          label="Código de Barra"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      <v-col cols="12" sm="6" md="5">
        <v-autocomplete
          v-model="entry.brandId"
          v-bind="getObject('brandId')"
          label="Marca"
          :items="extraData.accountGlobalSharedContext.allBrandsOfItems"
          item-value="id"
          item-text="name"
          autocomplete="off"
          :disabled="readOnly"
        >
          <template v-slot:append-outer>
            <BrandNew
              :inlineAddButton="true"
              @entry-created="brandCreated"
              withType="item"
            />
          </template>
        </v-autocomplete>
      </v-col>

      <v-col cols="12" sm="6" md="3">
        <v-autocomplete
          v-model="entry.unitId"
          v-bind="getObject('unitId')"
          label="Unidade de Consumo"
          :items="extraData.globalContext.allUnits"
          item-value="id"
          item-text="name"
          @input="getPackagingsForUnit(true)"
          autocomplete="off"
          :disabled="readOnly"
        />
      </v-col>

      
      
      <v-col cols="12" class="px-0"> 
        <MultiSelect
          v-model="entry.packagingIds"
          v-bind="getObject('packagingIds')"
          label="Embalagens"
          :items="packagingsList"
          :loadingItems="packagingsListLoading"          
          :key="packagingsListKey"
          :readOnly="entry.unitId ? readOnly : true"
        >
           <template v-slot:new_action>
            <PackagingNew
              :inlineAddButton="true"
              @entry-created="packagingCreated"
            />
          </template>
        </MultiSelect>
      </v-col>

    </v-row>
  </v-form>
</template>

<script>
import MaskedTextField from "@shared_components/masked_text_field.vue"
import MultiSelect from "@shared_components/multi_select.vue";
import gql from 'graphql-tag'
import BrandNew from "@models/brands/new.vue"
import VarietyNew from "@models/varieties/new.vue"
import PackagingNew from "@models/packagings/new.vue"
import BaseUtil from "@shared_components/base_util.vue"

export default {
  data() {
    return {
      entryAttributes: {},
      packagingsListLoading: false,
      packagingsList: [],
      packagingsListKey: 0,
      pageLoading: false,
    };
  },
  props: {
    entry: Object,
    extraData: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    MaskedTextField: MaskedTextField,
    MultiSelect: MultiSelect,    
    BrandNew: BrandNew,
    BaseUtil: BaseUtil,
    PackagingNew: PackagingNew,
    VarietyNew: VarietyNew,
  },
  created() {
    this.entryAttributes = this.setupEntryAttributes(this.entry);
  },
  mounted() {
    if (this.entry.unitId) {
      this.getPackagingsForUnit(false);
    }
  },
  methods: {
    getObject: function(element, component) {
      return this.entryAttributes[element];
    },
    isFormValid: function() {
      if (this.$refs.form.validate()) {
        return true;
      } else {
        setTimeout(function(){
          document.querySelector(".v-messages.error--text:first-of-type").scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 500);
      }
      return false;
    },
    resetFormInputs: function() {
      this.$refs.form.resetValidation();
    },  
    getPackagingsForUnit: function(hasChanged) {
      if (hasChanged) {
        this.entry.packagingIds = [];
      }
      this.packagingsListLoading = true;
      this.$apollo
        .query({
          query: AVAILABLE_PACKAGING_BY_UNIT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            unitId: this.entry.unitId
          }
        })
        .then(response => {
          // console.log("cities", response.data, this.entry);
          this.packagingsList = response.data.accountGlobalSharedContext.availablePackagingsByUnit;
          this.packagingsListKey++;
          // if (this.entry.unit) {
          //   this.entry.unitId = this.entry.unit.id;
          // }
        })
        .catch(response => console.log(response))
        .finally(() => (this.packagingsListLoading = false));
    },    
    brandCreated: function(brand) {
      if (brand.brandType == "item") {
        this.extraData.accountGlobalSharedContext.allBrandsOfItems.unshift(brand);
        this.entry.brandId = brand.id;
        this.entry.brand = brand;
      } else {
        this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      }
    },
    varietyCreated: function(variety) {
      this.extraData.globalContext.allVarieties.unshift(variety);
      this.entry.varietyId = variety.id;
      this.entry.variety = variety;
    },
    packagingCreated: function(packaging) {
      // if (brand.brandType == "item") {
      this.packagingsList.unshift(packaging);
      this.entry.packagingIds.push(packaging.id);
      // this.entry.brand = brand;
      // } else {
      //   this.$refs.util.showErrorMessage("A Marca cadastrada não é do tipo Item, por isso não irá aparecer na lista de marcas!");
      // }
    },
  }
};
const AVAILABLE_PACKAGING_BY_UNIT_QUERY = gql `
  query ($unitId: ID!) {
    accountGlobalSharedContext {
      availablePackagingsByUnit(unitId: $unitId) {
        id
        name
      }
    }
  }
`;
</script>

<style scoped></style>
